<template>
  <Day day="08.12.2025">
    <div slot="page-content">
      <h3>Hellooo Hamburg</h3>
      <p>
        <img src="@/assets/day8.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day08',
  components: {
    Day
  }
}
</script>
